export const hexToRgb = hex => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

	return result
		? [
				parseInt(result[1], 16),
				parseInt(result[2], 16),
				parseInt(result[3], 16)
		  ]
		: [0, 0, 0];
};

export const rgbToHex = (r, g, b) =>
	"#" +
	[r, g, b]
		.map(x => {
			const hex = Math.round(x).toString(16);
			return hex.length === 1 ? "0" + hex : hex;
		})
		.join("")
		.toUpperCase();

export const lightenColor = (color, percent = 100) => {
	if (color.startsWith("#")) {
		const [r, g, b] = hexToRgb(color);

		return rgbToHex(
			Math.min(255, r + ((255 - r) * percent) / 100),
			Math.min(255, g + ((255 - g) * percent) / 100),
			Math.min(255, b + ((255 - b) * percent) / 100)
		);
	}

	return color;
};

export const randomColorForCheckpoint = () => {
	return `#${Math.floor(Math.random() * 0x1000000)
		.toString(16)
		.padStart(6, 0)}`;
};

export const randomAdditivePastel = (excluded = 56) =>
	Math.floor(Math.random() * (200 - excluded + 1)) + excluded;

export const randomColor = excluded => {
	const r = randomAdditivePastel(excluded);
	const g = randomAdditivePastel(excluded);
	const b = randomAdditivePastel(excluded);

	const rHex = r.toString(16).padStart(2, "0");
	const gHex = g.toString(16).padStart(2, "0");
	const bHex = b.toString(16).padStart(2, "0");

	return `#${rHex}${gHex}${bHex}`;
};

// Based on: https://stackoverflow.com/a/35970186
export const invertColor = (hex, onlyBlackAndWhite = true) => {
	if (hex.indexOf("#") === 0) {
		hex = hex.slice(1);
	}

	// convert 3-digit hex to 6-digits.
	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	if (hex.length !== 6) {
		return null;
	}

	var r = parseInt(hex.slice(0, 2), 16),
		g = parseInt(hex.slice(2, 4), 16),
		b = parseInt(hex.slice(4, 6), 16);

	// https://stackoverflow.com/a/3943023/112731
	if (onlyBlackAndWhite) {
		return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
	}

	r = (255 - r).toString(16).padStart(2, "0");
	g = (255 - g).toString(16).padStart(2, "0");
	b = (255 - b).toString(16).padStart(2, "0");

	return `#${r}${g}${b}`;
};
